import cookies from 'browser-cookies';

export const AUTH_TOKEN_KEY = 'airSlate.session.token';
export const fetchAuthToken = (): string | null => cookies.get(AUTH_TOKEN_KEY);

